<template>
    <t-form label-width="80px">
        <CptData :data="props.attribute.cptTableData" :cptDataForm="props.cptDataForm"/>
        <t-form-item label="标签">
            <t-input size="small" v-model="props.attribute.label" />
        </t-form-item>
        <t-form-item label="显示标签">
            <t-switch v-model="props.attribute.showLable" size="small" :label="['开', '关']" />
        </t-form-item>
        <t-form-item label="显示电话">
            <t-switch v-model="props.attribute.showPhone" size="small" :label="['开', '关']" />
        </t-form-item>
        <t-form-item label="尺寸">
            <t-radio-group v-model="props.attribute.size">
                <t-radio-button value="small">小</t-radio-button>
                <t-radio-button value="medium">中</t-radio-button>
                <t-radio-button value="large">大</t-radio-button>
            </t-radio-group>
        </t-form-item>
        <t-form-item label="文本颜色">
            <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="props.attribute.textColor" enableAlpha size="small"/>
        </t-form-item>
        <t-form-item label="图库选择">
            <div @click="showGallery" style="width: 168px; height: 160px">
              <t-image style="width: 50%; height: 50%;  background: none" :src="attribute.url? fileUrl + attribute.url: require('@/assets/logo.png') " fit="fill" />
            </div>
        </t-form-item>
        <Gallery ref="gallery" @confirmCheck="confirmCheck" />
        <t-form-item label="图片宽度">
            <t-input-number
              size="small"
              :min="0"
              :max="9999"
              v-model="attribute.width"
              :decimal-places="0"
            />
          </t-form-item>
          <t-form-item label="图片高度">
            <t-input-number
              size="small"
              :min="0"
              :max="9999"
              v-model="attribute.height"
              :decimal-places="0"
            />
          </t-form-item>
          <t-form-item label="图片间距">
            <t-input-number
              size="small"
              :min="0"
              :max="9999"
              v-model="attribute.left"
              :decimal-places="0"
            />
          </t-form-item>
          <t-form-item label="填充方式">
            <t-select
              v-model="attribute.fit"
              placeholder="请选择填充方式"
              size="small"
            >
              <t-option label="fill" value="fill" />
              <t-option label="contain" value="contain" />
              <t-option label="cover" value="cover" />
              <t-option label="none" value="none" />
              <t-option label="scale-down" value="scale-down" />
            </t-select>
          </t-form-item>
          <t-form-item label="自动旋转">
            <t-radio-group v-model="attribute.autoRotate" size="small">
              <t-radio :value="true">开启</t-radio>
              <t-radio :value="false">关闭</t-radio>
            </t-radio-group>
          </t-form-item>
          <t-form-item label="自旋时长(s)">
            <t-input-number
              :min="1"
              :max="60"
              v-model="attribute.rotateDuration"
              size="small"
              :decimal-places="0"
            />
          </t-form-item>
          <t-form-item label="背景颜色">
            <t-color-picker
              :colorModes="['monochrome']"
              format="RGBA"
              v-model="attribute.bgColor"
              enableAlpha
              size="small"
            />
          </t-form-item>
    </t-form>
</template>

<script setup>
import env from "/env";
import { ref } from "vue";
import Gallery from "@/components/designer/gallery";
import CptData from '@/components/element/options/comp/cpt-data'
let gallery = ref(null);
let fileUrl = ref(env.fileUrl);

const props = defineProps({
    attribute: Object,
    cptDataForm: Object
})

let showGallery = () => {
  gallery.value.opened();
};

let confirmCheck = (url) => {
  props.attribute.url = url;
};
</script>